import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  class: "app-main",
  id: "main"
}
const _hoisted_3 = { class: "side" }
const _hoisted_4 = { class: "content" }

import {onUpdated} from "vue";
import {BulbOutlined, SettingOutlined} from "@ant-design/icons-vue";
import app from "@/model/app";


export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutView',
  setup(__props) {


onUpdated(() => {
  document.getElementsByClassName('content').item(0)?.scrollTo(0, 0)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_float_button = _resolveComponent("a-float-button")!
  const _component_a_float_button_group = _resolveComponent("a-float-button-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view, { name: "header" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view, { name: "side" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_view),
        _cache[1] || (_cache[1] = _createElementVNode("div", { id: "app-drawer" }, null, -1))
      ]),
      _createVNode(_component_a_float_button_group, { trigger: "hover" }, {
        icon: _withCtx(() => [
          _createVNode(_unref(SettingOutlined))
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_float_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(app).active.theme.dark = !_unref(app).active.theme.dark)),
            tooltip: _unref(app).active.theme.dark ? '亮色' : '暗色'
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(BulbOutlined))
            ]),
            _: 1
          }, 8, ["tooltip"])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})